export enum DocumentPageType {
    PortalDepartmentInfo = "portalDepartmentInfo",
    PortalCatalogPage = "portalCatalogPage",
    PortalCareerLobby = "portalCareerLobby",
    PortalMessagesPage = "portalMessages",
    PortalEventsPage = "portalEventsPage",
    PortalArticlesPage = "portalArticlesPage"
}